(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('animejs')) :
  typeof define === 'function' && define.amd ? define(['exports', 'animejs'], factory) :
  (global = global || self, factory(global.vuenime = {}, global.anime));
}(this, function (exports, anime) { 'use strict';

  anime = anime && anime.hasOwnProperty('default') ? anime['default'] : anime;

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  var isArray = function isArray(obj) {
    return Array.isArray(obj);
  };
  var isObject = function isObject(obj) {
    return _typeof(obj) === 'object' && !isArray(obj);
  };

  var script = {
    props: {
      value: {
        type: [Number, String, Array, Object],
        required: true
      },
      render: {
        type: Function,
        "default": null
      },
      duration: {
        type: Number,
        "default": 1000
      },
      delay: {
        type: Number,
        "default": 0
      },
      endDelay: {
        type: Number,
        "default": 0
      },
      easing: {
        type: String,
        "default": 'easeOutElastic(1, .5)'
      },
      round: {
        type: Number,
        "default": 0
      },
      direction: {
        type: String,
        "default": 'normal',
        validator: function validator(value) {
          return ['normal', 'reverse', 'alternate'].includes(value);
        }
      },
      loop: {
        type: [Number, Boolean],
        "default": false
      }
    },
    data: function data() {
      return {
        target: this.value,
        animationTarget: null,
        animation: null
      };
    },
    computed: {
      animationParameters: function animationParameters() {
        var duration = this.duration,
            delay = this.delay,
            endDelay = this.endDelay,
            easing = this.easing,
            round = this.round,
            direction = this.direction,
            loop = this.loop;
        return {
          duration: duration,
          delay: delay,
          endDelay: endDelay,
          easing: easing,
          round: round,
          direction: direction,
          loop: loop
        };
      }
    },
    watch: {
      value: function value() {
        this.resetAnimation();

        if (isArray(this.value)) {
          this.animateArray();
        } else if (isObject(this.value)) {
          this.animateObject();
        } else {
          this.animatePrimitive();
        }
      }
    },
    methods: {
      animatePrimitive: function animatePrimitive() {
        this.animationTarget = this;
        this.animation = anime(_objectSpread2({
          targets: this,
          target: this.value
        }, this.animationParameters));
      },
      animateArray: function animateArray() {
        var _this = this;

        var target = this.target,
            value = this.value;
        var valueLength = value.length;
        var targetLength = target.length;

        if (targetLength < valueLength) {
          // enter
          this.target = [].concat(_toConsumableArray(target), [value.slice(targetLength)]);
        } else if (targetLength > valueLength) {
          // exit
          this.target = target.slice(0, valueLength);
        }

        if (valueLength > 0) {
          // update
          var updatingTarget = {};
          var updateValues = {};

          for (var i = 0; i < valueLength; i += 1) {
            updatingTarget[i] = this.target[i];
            updateValues[i] = this.value[i];
          }

          this.animationTarget = updatingTarget;
          this.animation = anime(_objectSpread2({
            targets: this.animationTarget
          }, updateValues, {}, this.animationParameters, {
            update: function update() {
              _this.target = Object.values(updatingTarget);
            }
          }));
        }
      },
      animateObject: function animateObject() {
        var _this2 = this;

        var currentKeys = Object.keys(this.target);
        var nextKeys = Object.keys(this.value);
        var currentKeysLength = currentKeys.length;
        var nextKeysLength = nextKeys.length;
        var enterKeys = [];
        var leaveKeys = [];
        var updateKeys = [];

        for (var i = 0; i < nextKeysLength; i += 1) {
          var key = nextKeys[i];

          if (currentKeys.includes(key)) {
            updateKeys.push(key);
          } else {
            enterKeys.push(key);
          }
        }

        for (var _i = 0; _i < currentKeysLength; _i += 1) {
          var _key = currentKeys[_i];

          if (!nextKeys.includes(_key)) {
            leaveKeys.push(_key);
          }
        }

        var enterKeysLength = enterKeys.length;
        var leaveKeysLength = leaveKeys.length;
        var updateKeysLength = updateKeys.length; // enter

        for (var _i2 = 0; _i2 < enterKeysLength; _i2 += 1) {
          var _key2 = enterKeys[_i2];
          this.target[_key2] = this.value[_key2];
        } // levae


        for (var _i3 = 0; _i3 < leaveKeysLength; _i3 += 1) {
          delete this.target[leaveKeys[_i3]];
        } // update


        if (updateKeysLength > 0) {
          var animatingObject = {};
          var animationValues = {};

          for (var _i4 = 0; _i4 < updateKeysLength; _i4 += 1) {
            var _key3 = updateKeys[_i4];
            animatingObject[_key3] = this.target[_key3];
            animationValues[_key3] = this.value[_key3];
          }

          this.animationTarget = animatingObject;
          this.animation = anime(_objectSpread2({
            targets: this.animationTarget
          }, animationValues, {}, this.animationParameters, {
            update: function update() {
              _this2.target = _objectSpread2({}, _this2.target, {}, animatingObject);
            }
          }));
        }
      },
      resetAnimation: function resetAnimation() {
        if (this.animation) {
          this.animation.pause();
        }

        if (this.animationTarget) {
          anime.remove(this.animationTarget);
        }
      }
    },
    render: function render() {
      var renderFunction = this.render || this.$scopedSlots["default"];
      return typeof renderFunction === 'function' ? renderFunction(this.target) : null;
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  /* script */
  var __vue_script__ = script;
  /* template */

  /* style */

  var __vue_inject_styles__ = undefined;
  /* scoped */

  var __vue_scope_id__ = undefined;
  /* module identifier */

  var __vue_module_identifier__ = undefined;
  /* functional template */

  var __vue_is_functional_template__ = undefined;
  /* style inject */

  /* style inject SSR */

  var _vuenime = normalizeComponent_1({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

  var Vuenime = _vuenime["default"] || _vuenime;
  var main = {
    install: function install(Vue) {
      Vue.component('vuenime', Vuenime);
    }
  };

  exports.Vuenime = Vuenime;
  exports.default = main;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
